import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Integrantes`}</h2>
    <ul>
      <li parentName="ul">{`Juan Sebastian Paez Arroyo - `}<a parentName="li" {...{
          "href": "mailto:jspaeza@unal.edu.co"
        }}>{`jspaeza@unal.edu.co`}</a></li>
      <li parentName="ul">{`Duvan Alberto Andrade Cuenca - `}<a parentName="li" {...{
          "href": "mailto:daandradec@unal.edu.co"
        }}>{`daandradec@unal.edu.co`}</a></li>
      <li parentName="ul">{`Brayan Orlando Hurtado Plazas - `}<a parentName="li" {...{
          "href": "mailto:bohurtadop@unal.edu.co"
        }}>{`bohurtadop@unal.edu.co`}</a></li>
      <li parentName="ul">{`Miller Alexander Correa Gonzalez - `}<a parentName="li" {...{
          "href": "mailto:macorreag@unal.edu.co"
        }}>{`macorreag@unal.edu.co`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      